import { types as t } from 'mobx-state-tree';
import { gameDetailStore } from './gameDetail';

export const gameAdvancedInfo = t.model({   //TODO remove, legacy
    CombRateMin: t.maybeNull(t.number),
    CombCountMin: t.maybeNull(t.number),
    System: t.maybeNull(t.boolean),
    StakeMax: t.maybeNull(t.number)
}).views((self) => {
    return {
        get showInfoIcon() {
            return !self.System || !!self.CombCountMin || !!self.CombRateMin || !!self.StakeMax ? true : false;
        }
    }
})

export const gameStore = t.compose(t.model({
    BusinessType: t.number,
    Details: t.array(gameDetailStore),
    ID: t.string,
    IsDetails: t.maybeNull(t.boolean),
    Name: t.maybeNull(t.string),
    Sequence: t.number,
    Info: t.maybeNull(t.string),
}), gameAdvancedInfo);


